<template>
  <span>
    {{ formatAndDisplayPhoneNumber() }}
  </span>
</template>

<script>
import { formatPhoneNumber } from '../../utils';

export default {
  props: {
    phoneNumber: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    formatAndDisplayPhoneNumber() {
      return this.phoneNumber ? formatPhoneNumber(this.phoneNumber) : '';
    },
  },
};
</script>
